export default __webpack_public_path__ + "static/media/Drawing Card Swish 2.407150d5.mp3";